/* eslint-disable arrow-parens */
/* eslint-disable comma-dangle */
/* eslint-disable operator-linebreak */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-console */
import React, { Component } from 'react';
import QrReader from 'react-qr-reader';
import PropTypes from 'prop-types';

import { Paragraph, MainContainer, Button } from './StyledComponents';
import { deviceStorage } from '../services/calls';
import base64Conversion from '../services/base64conversion';
import userInfoObjectCreator from '../services/userInfoObjectCreator';
import deviceInfoGenerator from '../services/deviceInfoGenerator';
import studentActivationInfo from '../services/studentActivationInfo';

export default class QRCodeScanner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      result: null,
      facingMode: 'environment',
      legacyMode: false,
    };

    this.handleError = this.handleError.bind(this);
    this.handleScan = this.handleScan.bind(this);
    this.handleImgSubmit = this.handleImgSubmit.bind(this);
  }

  async handleScan(data) {
    const { history } = this.props;
    if (data && typeof data !== 'object') {
      const result = JSON.parse(data);
      // JCF- Fremont
      // HUNTINGTON - Huntington
      // TESTHS - Test high school
      // ECR - ecrchs
      // eslint-disable-next-line no-prototype-builtins
      if (result.hasOwnProperty('code')) {
        let sameDomain = false;
        switch (window.location.hostname) {
          case 'id-fremont.360isuite.com':
            if (result.code === 'JCF') sameDomain = true;
            break;
          case 'id-huntington.360isuite.com':
            if (result.code === 'HUNTINGTON') sameDomain = true;
            break;
          case 'id-ecrchs.360isuite.com':
            if (result.code === 'ECR') sameDomain = true;
            break;
          case 'id-tesths.360isuite.com':
            if (result.code === 'TESTHS') sameDomain = true;
            break;
          default:
            if (result.code === 'TESTHS');
            break;
        }
        if (sameDomain) {
          if (
            result.fn &&
            result.ln &&
            result.id &&
            result.no &&
            result.sch &&
            result.grd &&
            result.logo &&
            result.photo &&
            result.code &&
            result.showId
          ) {
            const newRes = {
              first_name: result.fn,
              last_name: result.ln,
              student_id: result.id,
              student_no: result.no,
              school_name: result.sch,
              grade: result.grd,
              school_logo: result.logo,
              student_photo_url: result.photo,
              school_code: result.code,
              show_id: result.showId,
              direct_url: result.dUrl,
              lpass: result.lpass,
            };
            const userInfo = userInfoObjectCreator(newRes);
            const [os, device] = deviceInfoGenerator();
            const online = navigator.onLine;
            if (online) {
              const header = base64Conversion();
              // api call
              await deviceStorage(
                // eslint-disable-next-line radix
                parseInt(newRes.student_id),
                newRes.student_no,
                newRes.school_code,
                os,
                device
              )
                .then(res => res.json())
                .then(async res => {
                  if (res.status === 200) {
                    localStorage.setItem(
                      'studentDetails',
                      JSON.stringify(userInfo)
                    );
                    localStorage.setItem('qrData', JSON.stringify(newRes));
                    if (newRes.student_photo_url !== '' && newRes.student_photo_url !== ' ') {
                      const objectToBeSent = {
                        school_code: newRes.school_code,
                        student_id: newRes.student_id,
                        student_no: newRes.student_no,
                      };
                      studentActivationInfo(objectToBeSent);
                    }
                    await fetch(process.env.REACT_APP_API_QR_DATA, {
                      method: 'POST',
                      body: JSON.stringify(newRes),
                      headers: {
                        Authorization: header,
                      },
                    })
                      .then(() => {
                         // console.log('Saved to Cache');
                        if (history) {
                          history.push('/studentDetails');
                        }
                      })
                      // .catch(err =>  console.log(`${err} could not be saved`));
                  } else {
                    this.setState({
                      result: 'Unable to register you. Please try again.',
                    });
                  }
                })
                .catch(err => {
                   // console.log(err);
                  this.setState({ result: 'Some Internal Error Occoured! ' });
                });
            }
          } else {
            this.setState({
              result:
                'Bad QR Code. Please Verify if you are scanning the correct code.',
            });
          }
        } else {
          this.setState({ result: 'Please scan correct QR.' });
        }
      } else {
        this.setState({ result: 'Incomplete Information. Please scan again' });
      }
    }
  }

  handleError() {
    this.setState({ result: 'Please Try Again!', legacyMode: true });
  }

  handleImgSubmit() {
    // eslint-disable-next-line react/no-string-refs
    this.refs.reader.openImageDialog();
  }

  render() {
    const { result, facingMode, legacyMode } = this.state;
    return (
      <div>
        {!legacyMode ? (
          <div style={{ height: '100vh', width: '100vw' }}>
            <QrReader
              delay={300}
              onError={this.handleError}
              onScan={this.handleScan}
              style={{ height: '100vh', width: '100vw' }}
              facingMode={facingMode}
              legacyMode={legacyMode}
              className="qr-scanner"
            />
          </div>
        ) : (
          <MainContainer>
            <Paragraph>
              Unfortunately we do not support QR Code Scanning, but please
              upload a photo
            </Paragraph>
            <Button onClick={this.handleImgSubmit}>QR Code Image</Button>
            <QrReader
              onScan={this.handleScan}
              onError={this.handleError}
              onLoad={this.handleLoad}
              facingMode={facingMode}
              delay={false}
              onImageLoad={this.handleImageLoad}
              legacyMode={legacyMode}
              // eslint-disable-next-line react/no-string-refs
              ref="reader"
            />
          </MainContainer>
        )}
        <Paragraph className="qr-status">{result}</Paragraph>
      </div>
    );
  }
}

QRCodeScanner.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  history: PropTypes.object.isRequired,
};
